import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ConversationSection from './ConversationSection';

const ConversationSectionWrapper = ({ sectionData }) => {
  const [currentSections, setCurrentSections] = useState([]);
  const activeConversation = useSelector((state) => state.activeSection);

  useEffect(() => {
    if (activeConversation !== null) {
      const tempSections = [...currentSections];

      if (sectionData[activeConversation]) {
        tempSections.push(sectionData[activeConversation]);
        setCurrentSections(tempSections);
      }
    }
  }, [activeConversation]);

  return currentSections.map((sectionData, index) => (
    <ConversationSection key={index} index={index} data={sectionData} />
  ));
};

export default ConversationSectionWrapper;
